import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import LovUsersGroups from "src/components/Lov/UsersGroups";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { IComponentGroupsUser } from "./interface";

const GroupsUser: React.FC<IComponentGroupsUser> = ({
	control,
	error,
	clearErrors,
	defaultValue
}) => {
	const { translate } = useTranslation();

	const { 
		fields, 
		remove,
		append
	} = useFieldArray({
		control,
		name: "eftba004"
	});

	const addEfa004 = () => {
		clearErrors("eftba004");
		const efa004: any = {};
		efa004.key = v4();
		efa004.efa004Id = "0";
		efa004.efa004Descricao = "";

		append(efa004);
	};

	const removeEfa004 = (index: number) => {	
		clearErrors("eftba004");		
		remove(index);
	};

	useEffect(() => {
		append(defaultValue.map((df) => ({
			key: v4(),
			...df
		})));
	}, []);

	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			<RCCGrid
				container
				item
			>
				<RCCGrid
					container
					item
					justifyContent="flex-end"
				>
					<RCCTooltip
						color="purple"
						text={translate("Adicionar grupo de usuário")}
						position="leftEnd"
					>
						<RCCButton
							color="purple"
							icon={{
								name: "plus"
							}}
							layout="isRounded"
							size="md"
							onClick={addEfa004}
						/>
					</RCCTooltip>
				</RCCGrid>
			</RCCGrid>
								
			<RCCGrid
				container
				item
			>
				{error.eftba004 && error.eftba004.message && (
					<Title color="red" size="xs">
						<RCCIcon
							name="infoCircle"
							color="var(--red)"
							style={{ marginRight: "8px"}}
						/>
						{error.eftba004.message}
					</Title>
				)}
				{fields.length === 0 && (
					<RCCAlert
						color="grey"
						title={translate("Nenhum grupo de usuário adicionado")}
						description={translate("Aperte no botão acima para adicionar")}
					/>
				)}
				
				{fields.map((miles: any, index) => (
					<RCCGrid
						container
						item
						alignItems="center"
						key={miles.key}
						spacing={1}
					>
						<RCCGrid
							container
							item
							justifyContent="center"
							xs={10}
							sm={10}
						>
							<LovUsersGroups 
								control={control}
								name={`eftba004[${index}].efa004Id`}
								label={translate("Grupo de usuários")}
								defaultValue={miles.efa004Id !== "0" && { value: String(miles.efa004Id), label: miles.efa004Descricao }}
								error={error.eftba004 && error.eftba004[index]?.efa004Id}
								required
							/>
						</RCCGrid>
						<RCCGrid
							container
							item
							justifyContent="flex-end"
							xs={2}
							sm={2}
						>
							<RCCTooltip
								color="red"
								text={translate("Excluir")}
							>
								<RCCButton
									color="transparent"
									icon={{
										name: "trash",
										color: "var(--red)"
									}}
									layout="isRounded"
									onClick={() => removeEfa004(index)}
									tabIndex={-1}
									disabled={fields.length < 2}
								/>
							</RCCTooltip>
						</RCCGrid>
					</RCCGrid>											
				))}
			</RCCGrid>
		</RCCGrid>
	);
};

export default GroupsUser;
